<template>
    <section class="o-page-bottom-spacing">
        
        <div class="o-wrapper o-wrapper--center">

            <h1 class="c-page-title">{{ $t('warranty.page_title') }}</h1>

            <p v-html="WarrantyIntro"></p>

            <h1 class="c-page-title">{{ $t('warranty.procedure.title') }}</h1>

            <ul class="u-margin-left-none">
                <li>{{ $t('warranty.procedure.rule1_label') }}</li>
                <li>{{ $t('warranty.procedure.rule2_label') }}</li>
                <li>{{ $t('warranty.procedure.rule3_label') }}</li>
                <li>{{ $t('warranty.procedure.rule4_label') }}</li>
                <li>{{ $t('warranty.procedure.rule5_label') }}</li>
                <li>{{ $t('warranty.procedure.rule6_label') }}
                    <ol>
                        <li>{{ $t('warranty.procedure.rule6_option1_label') }}</li>
                        <li>{{ $t('warranty.procedure.rule6_option2_label') }}</li>
                    </ol>
                </li>
            </ul>

            <h2 class="c-page-title">{{ $t('warranty.procedure.bad_examples_title') }}</h2>

            <div class="o-auto-grid o-auto-grid--small o-auto-grid--mobile-reverse u-margin-bottom-tiny">
                <div class="img-container">
                    <img src="@/assets/images/return_bad_example_1.jpg"/>
                    <div class="img-overlay-icon">
                        <svgicon class="u-color-error-base" name="cross"></svgicon>
                    </div>
                </div>
                <div class="img-container">
                    <img src="@/assets/images/return_bad_example_2.jpg"/>
                    <div class="img-overlay-icon">
                        <svgicon class="u-color-error-base" name="cross"></svgicon>
                    </div>
                </div>
            </div>
            <div class="o-auto-grid o-auto-grid--small o-auto-grid--mobile-reverse u-margin-bottom">
                <div class="img-container">
                    <img src="@/assets/images/return_bad_example_3.jpg"/>
                    <div class="img-overlay-icon">
                        <svgicon class="u-color-error-base" name="cross"></svgicon>
                    </div>
                </div>
                <div class="img-container">
                    <img src="@/assets/images/return_bad_example_4.jpg"/>
                    <div class="img-overlay-icon">
                        <svgicon class="u-color-error-base" name="cross"></svgicon>
                    </div>
                </div>
            </div>
            
            <h2 class="c-page-title">{{ $t('warranty.procedure.good_examples_title') }}</h2>

            <div class="o-auto-grid o-auto-grid--small o-auto-grid--mobile-reverse u-margin-bottom">
                <div class="img-container">
                    <img src="@/assets/images/return_good_example_1.jpg"/>
                    <div class="img-overlay-icon">
                        <svgicon class="u-color-success-base" name="check"></svgicon>
                    </div>
                </div>
                <div class="img-container">
                    <img src="@/assets/images/return_good_example_2.jpg"/>
                    <div class="img-overlay-icon">
                        <svgicon class="u-color-success-base" name="check"></svgicon>
                    </div>
                </div>
            </div>

            <h1 class="c-page-title">{{ $t('warranty.warranty_title') }}</h1>

            <form action="" class="c-form c-form--horizontal">

                <div class="u-max-700 c-form-row">
                    <v-form-row v-if="Personal.FirstName">
                        <v-input v-model="Personal.FirstName" name="first_name" :fluid="true" :disabled="true">
                            <slot slot="label">{{ $t('warranty.first_name.label') }}</slot>
                        </v-input>
                    </v-form-row>

                    <v-form-row v-if="Personal.LastName">
                        <v-input v-model="Personal.LastName" name="last_name" :fluid="true" :disabled="true">
                            <slot slot="label">{{ $t('warranty.last_name.label') }}</slot>
                        </v-input>
                    </v-form-row>

                    <v-form-row v-if="Personal.Email">
                        <v-input v-model="Personal.Email" name="email" :fluid="true" :disabled="true">
                            <slot slot="label">{{ $t('warranty.email.label') }}</slot>
                        </v-input>
                    </v-form-row>

                    <v-form-row v-if="Personal.PhoneNumber">
                        <v-input v-model="Personal.PhoneNumber" name="phone" :fluid="true" :disabled="true">
                            <slot slot="label">{{ $t('warranty.phone.label') }}</slot>
                        </v-input>
                    </v-form-row>

                    <v-form-row v-if="Customer.Street">
                        <v-input v-model="Customer.Street" name="address" :fluid="true" :disabled="true">
                            <slot slot="label">{{ $t('warranty.address.label') }}</slot>
                        </v-input>
                    </v-form-row>

                    <v-form-row v-if="Customer.Zipcode">
                        <v-input v-model="Customer.Zipcode" name="zipcode" :fluid="true" :disabled="true">
                            <slot slot="label">{{ $t('warranty.zipcode.label') }}</slot>
                        </v-input>
                    </v-form-row>

                    <v-form-row v-if="Customer.City">
                        <v-input v-model="Customer.City" name="city" :fluid="true" :disabled="true">
                            <slot slot="label">{{ $t('warranty.city.label') }}</slot>
                        </v-input>
                    </v-form-row>

                    <v-form-row v-if="Customer.CountryName">
                        <v-input v-model="Customer.CountryName" name="country" :fluid="true" :disabled="true">
                            <slot slot="label">{{ $t('warranty.country.label') }}</slot>
                        </v-input>
                    </v-form-row>

                    <v-form-row>
                        <v-input v-model="ArticleName" name="article_name" :fluid="true" :error="Validate.ArticleName">
                            <slot slot="label">{{ $t('warranty.article_name.label') }}</slot>
                        </v-input>
                    </v-form-row>

                    <v-form-row>
                        <v-input v-model="ArticleColor" name="article_color" :fluid="true" :error="Validate.ArticleColor">
                            <slot slot="label">{{ $t('warranty.article_color.label') }}</slot>
                        </v-input>
                    </v-form-row>

                    <v-form-row>
                        <v-input v-model="ArticleSize" name="article_size" :fluid="true" :error="Validate.ArticleSize">
                            <slot slot="label">{{ $t('warranty.article_size.label') }}</slot>
                        </v-input>
                    </v-form-row>

                    <v-form-row>
                        <v-textarea v-model="Complaint" :fluid="true" rows="7">
                            <slot slot="label">{{ $t('warranty.complaint.label') }}</slot>
                        </v-textarea>
                    </v-form-row>

                    <v-form-row>
                        <div class="c-form-item c-form-item--horizontal c-form-item--fluid">
                            <label class="c-label">{{ $t('warranty.defect_photo.label') }}</label>
                            <div class="u-inline-block u-pos-relative" style="width: 200px">
                                <v-picture-input
                                        :width="300"
                                        :height="200"
                                        :selected="DefectPhoto"
                                        @changed="setDefectPhoto">
                                </v-picture-input>
                            </div>
                        </div>
                    </v-form-row>

                    <v-form-row>
                        <div class="c-form-item c-form-item--horizontal c-form-item--fluid">
                            <label class="c-label">{{ $t('warranty.proof_of_purchase_photo.label') }}</label>
                            <div class="u-inline-block u-pos-relative" style="width: 200px">
                                <v-picture-input
                                        :width="300"
                                        :height="200"
                                        :selected="ProofOfPurchasePhoto"
                                        @changed="setProofOfPurchasePhoto">
                                </v-picture-input>
                            </div>
                        </div>
                    </v-form-row>

                    <v-form-row>
                        <div class="c-form_item c-form-item--horizontal u-margin-top u-margin-bottom">
                            <v-label></v-label>
                            <v-switch v-model="GDPR" name="stock_allowed">
                            </v-switch>
                            <span class="gdpr_warning u-font-small u-line-height-2-0">{{ $t('warranty.gdpr.label') }}</span>
                        </div>
                    </v-form-row>

                    <v-form-row>
                        <div class="c-form-item c-form-item--horizontal">
                            <v-label></v-label>
                            <button @click="submitForm" :disabled="!GDPR" class="c-button c-button--alpha">{{ $t('warranty.send.label') }}</button>                            
                        </div>
                    </v-form-row>

                </div>
            </form>
        </div>
    </section>
</template>

<script>
    import PageHeader from '@/components/common/PageHeader'

    // Forms
    import VTextarea from '@/components/form/Textarea'
    import VInput from '@/components/form/Input'
    import VFormRow from '@/components/form/Row'
    import VLabel from '@/components/form/Label'
    import VPictureInput from '@/components/form/PictureInput'
    import VSwitch from '@/components/form/Switch'
    import VChecklist from '@/components/checklist/Checklist'

    // Store
    import {mapGetters} from 'vuex'

    export default {
        components: {
            PageHeader,
            VTextarea,
            VLabel,
            VInput,
            VFormRow,
            VPictureInput,
            VSwitch,
            VChecklist
        },
        data() {
            return {
                GDPR: false,
                Name: "",
                ArticleName: "",
                ArticleColor: "",
                ArticleSize: "",  
                Complaint: "",
                DefectPhoto: "",
                ProofOfPurchasePhoto: "",          
                Validate: {}
            }
        },
        computed: {
            ...mapGetters({
                Personal: 'userPersonalData',
                Customer: 'Customer',
            }),
            WarrantyRequest() {
                return {
                    ArticleName: this.ArticleName,
                    ArticleColor: this.ArticleColor,
                    ArticleSize: this.ArticleSize,
                    Complaint: this.Complaint,
                    DefectPhoto: this.DefectPhoto,
                    ProofOfPurchasePhoto: this.ProofOfPurchasePhoto
                }
            },
            WarrantyIntro() {
                return this.$t('intro.warranty', {'url': this.$router.resolve({ name: 'Contact' }).href });
            }
        },
        created: function () {
            this.$store.dispatch('getUser');
            this.$store.dispatch('getCustomerById', this.$store.getters.userInfo.customerKey);
        },
        methods: {
            validateForm(response){
                let errors = response.data.ModelState;

                // Get error data from server, and transform to vue data
                Object.keys(errors).forEach(function(key) {
                    key = key.replace('model.', '');
                    errors[key] = errors['model.'+key][0];
                    delete errors['model.'+key];
                });

                this.Validate = errors;
            },
            setDefectPhoto(defectPhoto) {
                this.DefectPhoto = defectPhoto;
            },
            setProofOfPurchasePhoto(proofOfPurchasePhoto) {
                this.ProofOfPurchasePhoto = proofOfPurchasePhoto;
            },
            submitForm(e) {
                this.$store.dispatch('requestWarranty', this.WarrantyRequest).then((response) => {
                    if (response.status > 300) {
                        this.validateForm(response);
                    } else {
                        
                        this.ArticleName = "";
                        this.ArticleColor = "";
                        this.ArticleSize = "";
                        this.Complaint = "";
                        this.ProofOfPurchasePhoto = null;
                        this.DefectPhoto = null;

                        this.$notify({
                            group: 'global',
                            title: this.$t('warranty.request_succeeded'),
                            type: 'success',
                            duration: 4000
                        });
                    }
                });

                e.preventDefault();
            }
        }
    }
</script>

<style lang="scss">
    @import "~@/assets/scss/private";

    .gdpr_warning {
        margin-left: 15px;
    }

    .img-container {
        position: relative;
    }

    .img-overlay-icon {
        position: absolute;
        right: 5px;
        top: 5px;
    }

    .img-overlay-icon > svg {
        width: 100px;
        height: 100px;
    }
</style>


// WEBPACK FOOTER //
// src/views/common/Warranty.vue